import * as React from "react";
import { computed } from "mobx";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { Strings } from "../Stores/StringsStore";

@observer
export class FavouriteButton extends Button {

	@computed get classNames() {
		switch (this.props.switchState) {
			case 0:
				return "type-favourite-toolbar-bg-2";
			case 1:
				return "type-favourite-toolbar-bg-1";
			default:
				return "type-favourite-toolbar-bg-2";
		}
	}

	@computed get tooltip() {
		switch (this.props.switchState) {
			case 0:
				return Strings.reader.removeFavoriteButtonTooltip;
			case 1:
				return Strings.reader.addFavoriteButtonTooltip;
			default:
				return Strings.reader.removeFavoriteButtonTooltip;
		}
	}

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : this.tooltip}>
			<i className={this.classNames} />
		</Button>;
	}
}
